<template>
  <iframe
    :src="`https://view.officeapps.live.com/op/embed.aspx?src=${value}`"
    width="100%"
    height="100%"
    style="border: none;"
  />
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>
